import { apiRoutes } from 'constant';

import { post } from './http';

export const fetchStatsRequest = params => post(apiRoutes.STATS, params);
